<template>

    <li class="operation">

        <div>
            <p>
                <i :class="classTypeOp"></i>
                {{operation.type }} | {{ operation.quantite }} Kg
            </p>
        </div>

        <div class="bottom-op">

            <div class="bottle" v-if="bouteille != null">
                <i class="icon-gas"></i>
                {{ bouteille.code }}
            </div>

            <div class="refrigerant" v-if="fluide != null">
                <i class="icon-fluid"></i>
                {{ fluide.nom }}
            </div>

            <div class="delete" v-if="bouteille != null">
                <a v-show="bouteille.actif === true" @click.prevent="delOperation(operation.id)">
                    <i class="icon-delete"></i>
                </a>
            </div>

        </div>

    </li>

</template>

<script>
    import Bouteille from '../../../../js/models/Bouteille'
    import OperationBouteille from '../../../../js/models/OperationBouteille'
    import Fluide from '../../../../js/models/Fluide'

    export default {

        data() {
            return {
                bouteille: null,
                fluide: null
            }
        },

        props: {
            operation: null,
        },

        computed: {
            classTypeOp() {
                if (_.includes(this.operation.type, 'Ajout')) {
                    return 'icon-add'
                } else {
                    return 'icon-less'
                }
            }
        },

        mounted() {

            Bouteille
                .getBouteille(this.operation.id_bouteille)
                .then(data => {
                    this.bouteille = data
                });

            var fobj = new Fluide();

            fobj
                .getFluide(this.operation.id_fluide, res => {
                    this.fluide = res
                })

        },

        methods: {

            async delOperation(id) {

                //Permet de récupérer la dernière version de la bouteille
                let bouteille = await Bouteille.getBouteille(this.operation.id_bouteille)

                if (this.bouteille.type !== "Fluide frigorigène") {

                    let nouveauPoids = bouteille.poids_net;
                    //Les id_type sont en string, donc pas de === :)
                    if (this.operation.id_type == "5") {
                        nouveauPoids = bouteille.poids_net - this.operation.quantite;
                    } else if (this.operation.id_type == "2") {
                        nouveauPoids = bouteille.poids_net + this.operation.quantite;
                    }

                    if (nouveauPoids < 0) {
                        swal('Incohérence', "Vous devez d'abord supprimer la manipulation d'ajout de fluide recyclé", 'question')
                        return false;
                    }

                }


                if (this.bouteille.actif === true) {

                    let ObjOp = new OperationBouteille();

                    ObjOp
                        .cancelOperation(id)
                        .then(res => {
                            this.$emit('opDeleted', [res])
                        })
                        .catch()

                } else {

                    swal('Action non autorisée', "La bouteille utilisée pour cette opération est maintenant clôturée", 'error')

                }

            }

        }

    }

</script>

<style>

    li.operation {
        padding-bottom: 10px;
        margin-bottom: 10px;
        border-bottom: 1px solid #ccc;
    }

    .operation:last-child {
        border-bottom: none;
    }

    div.bottom-op {
        padding-top: 7px;
        display: flex;
        justify-content: space-between;
    }

    div.bottom-op a {
        height: 40px;
        width: 40px;
        color: #fff;
        line-height: 40px;
        text-align: center;
        background-color: #c31616;
        border-radius: 5px;
        font-size: 2.3rem;
        display: block;
    }

    div.bottom-op .bottle, div.bottom-op .refrigerant {
        position: relative;
        height: 40px;
        width: auto;
        padding: 0 10px;
        color: white;
        font-size: 1.8rem;
        font-weight: 700;
        border-radius: 5px;
        line-height: 2;
        border: 1px solid transparent;
        background-color: #999;
    }

    div.bottom-op .delete {
        width: 40px;
    }

    div.bottom-op .refrigerant {
        background-color: #393c51;
    }

</style>



// WEBPACK FOOTER //
// OperationBouteille.vue?40dcdcd6